import { createCookieForHours } from '../components/common/Cookie';

export const getAffiliatePayload = () => {
  const params = new URLSearchParams(window.location.search);

  const utmMedium = params.get('utm_medium');

  // Only proceed if channel is affiliate
  if (utmMedium !== 'affiliate') return null;

    params.delete('utm_medium');
    // Build correct URL with ?
    const newUrl = `${window.location.pathname}?${params.toString()}`;

    // Update URL without reload
    window.history.replaceState({}, document.title, newUrl);
  return {
    attributed_affiliate_name: params.get('utm_source'),
    attributed_affiliate_id: params.get('pid'),
    attributed_affiliate_campaign_id: params.get('offer_id'),
    attributed_affiliate_click_id: params.get('clickid'),
    attributed_affiliate_sub_id: 'NA',
    attributed_affiliate_additional_publisher_info: params.get('utm_term'),
    attributed_affiliate_campaign_medium: 'affiliate',
    attributed_affiliate_campaign_name: params.get('utm_campaign')
  };
};

export const getAffiliateCookie = () => {
  const cookie = document.cookie.split('; ').find(c => c.startsWith('affiliate_tracking='));
  const params = new URLSearchParams(window?.location?.search);

  const utmMedium = params.get('utm_medium');
  if (utmMedium !== 'affiliate' && utmMedium?.length > 0) return null;
  if (!cookie) return null;

  try {
    return JSON.parse(decodeURIComponent(cookie.split('=')[1]));
  } catch {
    return null;
  }
};

export const setAffiliateCookie = (affiliateFeatureConfig = {}) => {
  const newData = getAffiliatePayload();

  if (newData) {
    const oldData = getAffiliateCookie('affiliate_tracking');
    const attributionWindow = affiliateFeatureConfig?.attributionWindow || 0;
    if (!oldData) {
      // First affiliate click
      createCookieForHours(
        'affiliate_tracking',
        encodeURIComponent(JSON.stringify(newData)),
        attributionWindow
      );
    } else if (oldData.attributed_affiliate_id !== newData.attributed_affiliate_id) {
      // Different affiliate → overwrite
      createCookieForHours(
        'affiliate_tracking',
        encodeURIComponent(JSON.stringify(newData)),
        attributionWindow
      );
    }
    // Same affiliate → keep old cookie
  }
};
